export default {"src":"/login-app/[GIT_HASH]/_next/static/media/unfold_less.af16bf4f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};